import {Part} from "./part";
import {PartMenuType} from "../../../visComponents/constants";
import { showerAccessoriesThumbnail } from '../assets';
import LargeCornerSeat from "../subparts/showerAccessories/largeCornerSeat";
import SoapDish from "../subparts/showerAccessories/soapDish";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import SmallCornerShelf from "../subparts/showerAccessories/smallCornerShelf";
import CornerCaddie from "../subparts/showerAccessories/cornerCaddie";
import LargeCornerCaddie from "../subparts/showerAccessories/largeCornerCaddie";
import GrabBar from "../subparts/showerAccessories/grabBar";

export class ShowerAccessories extends Part {
  static id = 'Shower Accessories';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerAccessoriesThumbnail;
    this.partName = 'Shower Accessories';
    this.translateId = "visualizer.bathroom.accessories";
    this.relatedItems = [];

    // related items
    this.soapDish = null;
    this.largeCornerSeat = null;
    this.largeCornerCaddie = null;
    this.cornerCaddie = null;
    this.smallCornerShelf = null;
    this.grabBar = null;

    //current active caddie type
    this.caddie_type = "large_corner_caddie";

  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Soap Dish":
        relatedItemName = "soapDish";
        RelatedItemClass = SoapDish;
        break;
      case "Large Corner Seat":
        relatedItemName = "largeCornerSeat";
        RelatedItemClass = LargeCornerSeat;
        break;
      case "Large Corner Caddie":
        relatedItemName = "largeCornerCaddie";
        RelatedItemClass = LargeCornerCaddie;
        break;
      case "Corner Caddie":
        relatedItemName = "cornerCaddie";
        RelatedItemClass = CornerCaddie;
        break;
      case "Small Corner Shelf":
        relatedItemName = "smallCornerShelf";
        RelatedItemClass = SmallCornerShelf;
        break;
      case "Grab Bar":
        relatedItemName = "grabBar";
        RelatedItemClass = GrabBar;
        break;

    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  setLayers(layout, placeholdersNeeded) {
    const layers = [];
    this.getRelatedItems().forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(layers)
        : relatedItem.activeFeature && relatedItem.activeFeature.layer.addTo(layers)
    });

    return layers;
  }

  subParts() {
    return this.getRelatedItems().map(_ => new DesignNavigationItem(_.partName, _));
  }

  navigationItem() {
    return new DesignNavigationItem(this.partName, this)
  }

}

